export const INITIAL = {
	MODAL: {
		content: '',
		data: {},
	},
	VALUES: {
		name: '',
		description: '',
		goal: '',
		reward: '',
	},
	COLLAPSE: {
		adventure: false,
	},
	LIST: {
		columns: {
			name: true,
			description: true,
		},
		rows: [],
	},
}